import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch mb-8 d-flex flex-column" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3" }, "Filters"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-7" }, "Filter statistics")
], -1)
const _hoisted_4 = { class: "d-flex mt-5" }
const _hoisted_5 = { class: "w-100 me-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 ms-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateSelector = _resolveComponent("DateSelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_DateSelector, {
            onRangeSelected: _ctx.handleDateSelect,
            onCleared: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDateSelect(null)))
          }, null, 8, ["onRangeSelected"])
        ]),
        _hoisted_6
      ])
    ])
  ]))
}